// Notification Utilities für Chat-Benachrichtigungen

// Notification Permission anfordern
export const requestNotificationPermission = async () => {
  if (!("Notification" in window)) {
    console.log("Browser unterstützt keine Benachrichtigungen");
    return false;
  }

  if (Notification.permission === "granted") {
    return true;
  }

  if (Notification.permission !== "denied") {
    const permission = await Notification.requestPermission();
    return permission === "granted";
  }

  return false;
};

// Benachrichtigung anzeigen
export const showNotification = (title, options = {}) => {
  if (Notification.permission === "granted") {
    const notification = new Notification(title, {
      icon: '/logo192.png',
      badge: '/logo192.png',
      vibrate: [200, 100, 200],
      tag: 'chat-message',
      renotify: true,
      ...options
    });

    // Auto-close nach 5 Sekunden
    setTimeout(() => notification.close(), 5000);

    return notification;
  }
};

// Audio Context für Ton (mit User-Interaktion initialisiert)
let audioContext = null;
let audioUnlocked = false;

// Audio Context entsperren (muss durch User-Interaktion erfolgen)
export const unlockAudio = () => {
  if (audioUnlocked) return;
  
  try {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
    
    // Dummy-Sound abspielen um Audio zu entsperren
    const oscillator = audioContext.createOscillator();
    const gain = audioContext.createGain();
    gain.gain.value = 0.01; // Sehr leise
    oscillator.connect(gain);
    gain.connect(audioContext.destination);
    oscillator.start(0);
    oscillator.stop(0.01);
    
    audioUnlocked = true;
    console.log('🔊 Audio entsperrt');
  } catch (error) {
    console.warn('Audio konnte nicht entsperrt werden:', error);
  }
};

// Ton abspielen - Freundlicher Benachrichtigungston (ähnlich WhatsApp)
export const playNotificationSound = () => {
  try {
    if (!audioContext || audioContext.state === 'suspended') {
      audioContext?.resume();
    }
    
    if (!audioContext) {
      console.warn('Audio Context nicht initialisiert');
      return;
    }

    const now = audioContext.currentTime;
    
    // Erste Note (höher) - LAUTER
    const osc1 = audioContext.createOscillator();
    const gain1 = audioContext.createGain();
    osc1.connect(gain1);
    gain1.connect(audioContext.destination);
    osc1.frequency.value = 600; // E5
    osc1.type = 'sine';
    gain1.gain.setValueAtTime(0.4, now); // Erhöht von 0.15 auf 0.4
    gain1.gain.exponentialRampToValueAtTime(0.01, now + 0.15);
    osc1.start(now);
    osc1.stop(now + 0.15);

    // Zweite Note (tiefer) - nach kurzer Pause - LAUTER
    const osc2 = audioContext.createOscillator();
    const gain2 = audioContext.createGain();
    osc2.connect(gain2);
    gain2.connect(audioContext.destination);
    osc2.frequency.value = 480; // D5
    osc2.type = 'sine';
    gain2.gain.setValueAtTime(0.4, now + 0.08); // Erhöht von 0.15 auf 0.4
    gain2.gain.exponentialRampToValueAtTime(0.01, now + 0.25);
    osc2.start(now + 0.08);
    osc2.stop(now + 0.25);
    
  } catch (error) {
    console.error('Fehler beim Abspielen des Tons:', error);
  }
};

// Chat-Benachrichtigung mit Ton und Desktop-Notification
export const notifyNewMessage = (senderName, messagePreview) => {
  // Ton abspielen
  playNotificationSound();

  // Desktop-Benachrichtigung anzeigen
  showNotification(`Neue Nachricht von ${senderName}`, {
    body: messagePreview,
    icon: '/logo192.png',
    tag: `chat-${senderName}`,
  });
};
